<ng-form
  [formGroup]="generalCartForm"
  *ngIf="generalCartOptions"
  id="ng-form_b111c114"
>
  <!-- LOADING CARD-->
  <div class="options-card" id="div_options-card_8b46dcc1">
    <div class="options-card-header" id="div_options-card-header_25a9fbb3">
      LOADING
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_089b34bf"
    >
      <!--LOADING TYPE-->
      <div class="options-card-body" id="div_options-card-body_213a110d">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_47c2dccf"
        >
          How will these railcars be loaded?
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_45bc9615"
        >
          <p-checkbox
            class="checkbox-option"
            *ngFor="
              let option of generalCartOptions['loading-type'];
              let first = first
            "
            [class.first]="first"
            [formControl]="$any(generalCartForm.controls['loading-type'])"
            [value]="option"
            [label]="option.name"
            id="p-checkbox_checkbox-option_21b57989"
          ></p-checkbox>

          <div
            *ngIf="
              generalCartForm.controls['loading-type'].invalid &&
              (generalCartForm.controls['loading-type'].dirty ||
                generalCartForm.controls['loading-type'].touched)
            "
            class="error-text"
            id="div_error-text_a640f9c7"
          >
            <div
              *ngIf="
                generalCartForm.controls['loading-type'].errors?.['required']
              "
              id="div_69e0691d"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <!--MANWAY TYPE-->
      <div
        class="options-card-body"
        *ngIf="manwayLoading"
        id="div_options-card-body_30c2e5d9"
      >
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_44e4ef49"
        >
          Please select manway type
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_306eeff5"
        >
          <p-checkbox
            class="checkbox-option"
            *ngFor="
              let option of generalCartOptions['manway-type'];
              let first = first
            "
            [class.first]="first"
            [value]="option"
            [formControl]="$any(generalCartForm).controls['manway-type']"
            [label]="option.name"
            id="p-checkbox_checkbox-option_361f1fd4"
          ></p-checkbox>
        </div>
      </div>

      <!--LIQUID VALVE TYPE-->
      <div
        class="options-card-body"
        *ngIf="liquidLoading"
        id="div_options-card-body_ad5d8651"
      >
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_b8a4bae9"
        >
          Please select liquid valve type
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_ac9894ae"
        >
          <p-multiSelect
            placeholder="Select liquid valve type"
            styleClass="multi-select-pressure-cart"
            optionLabel="name"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            [showClear]="false"
            [showHeader]="false"
            formControlName="liquid-valve-type"
            [options]="generalCartOptions['liquid-valve-type']"
            id="p-multiSelect_52924eda"
          >
            <ng-template let-fg="" pTemplate="item" id="ng-template_d7b30872">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_15f95b53"
              >
                <div id="div_2481698a">{{ fg.name }}</div>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>

      <!--AIR VALVE TYPE-->
      <div class="options-card-body" id="div_options-card-body_4de0df83">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_283c361a"
        >
          What are your air valve requirements?
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_19dac456"
        >
          <p-multiSelect
            placeholder="Select air valve type"
            styleClass="multi-select-pressure-cart"
            [showToggleAll]="false"
            optionLabel="name"
            filterPlaceHolder="Search..."
            [class.error-label]="
              generalCartForm.controls['air-valve-type'].invalid &&
              (generalCartForm.controls['air-valve-type'].dirty ||
                generalCartForm.controls['air-valve-type'].touched)
            "
            [showClear]="false"
            [showHeader]="false"
            id="air-valve-type"
            formControlName="air-valve-type"
            [options]="generalCartOptions['air-valve-type']"
            (onChange)="onChangeAirValveType($event)"
          >
            <ng-template let-fg="" pTemplate="item" id="ng-template_29a2f3d5">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_ac21d79a"
              >
                <div id="div_098c9d3a">{{ fg.name }}</div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              generalCartForm.controls['air-valve-type'].invalid &&
              (generalCartForm.controls['air-valve-type'].dirty ||
                generalCartForm.controls['air-valve-type'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_fd0005a4"
          >
            <div
              *ngIf="
                generalCartForm.controls['air-valve-type'].errors?.['required']
              "
              id="div_05157787"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <!--AIR VALVE FITTINGS-->
      <div
        *ngIf="showAirValveFittings"
        class="options-card-body scale-in-ver-top"
        id="div_options-card-body_2ff82641"
      >
        <div
          class="options-card-subheader body-item"
          fxFlex.lt-lg="56"
          fxFlex.lg="42"
          fxFlex.gt-lg="40"
          id="div_options-card-subheader_11e68e82"
        >
          Select air valve connection to fittings plate.
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_4b67f14b"
        >
          <p-radioButton
            *ngFor="
              let vb of generalCartOptions['air-valve-fitting'];
              let first = first
            "
            class="checkbox-option"
            [class.first]="first"
            formControlName="air-valve-fitting"
            name="air-valve-fitting"
            [label]="vb.name"
            [value]="vb"
            id="p-radioButton_checkbox-option_bd8b38b1"
          ></p-radioButton>
        </div>
      </div>
    </div>
  </div>

  <!--UNLOADING CARD-->
  <div class="options-card" id="div_options-card_c00c5b56">
    <div class="options-card-header" id="div_options-card-header_e855384d">
      UNLOADING
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_b75a1a6a"
    >
      <!--UNLOAD TYPE-->
      <div class="options-card-body" id="div_options-card-body_a9461e1b">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_beaf92b6"
        >
          How will these railcars be unloaded?
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_5e3ec529"
        >
          <p-radioButton
            *ngFor="
              let vb of generalCartOptions['unloading-type'];
              let first = first
            "
            class="checkbox-option"
            [class.first]="first"
            name="unloading-type"
            formControlName="unloading-type"
            [label]="vb.name"
            [value]="vb"
            id="p-radioButton_checkbox-option_c428d744"
          ></p-radioButton>
        </div>
      </div>

      <!--BOV DETAIL-->
      <div
        *ngIf="
          generalCartForm.get('unloading-type')?.value &&
          generalCartForm.get('unloading-type')?.value.name !== 'Top Unloading'
        "
        class="options-card-body"
        id="div_options-card-body_f3561326"
      >
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_ffc5c15b"
        >
          Please select BOV detail.
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_482f56b4"
        >
          <p-radioButton
            *ngFor="
              let vb of generalCartOptions['bov-detail'];
              let first = first
            "
            class="checkbox-option"
            [class.first]="first"
            name="bov-detail"
            formControlName="bov-detail"
            [label]="vb.name"
            [value]="vb"
            id="p-radioButton_checkbox-option_057e1309"
          ></p-radioButton>
        </div>
      </div>

      <!--BOV AUX VALVE-->
      <div
        *ngIf="
          generalCartForm.get('unloading-type')?.value &&
          generalCartForm.get('unloading-type')?.value.name !==
            'Top Unloading' &&
          generalCartForm.get('bov-detail')?.value &&
          generalCartForm.get('bov-detail')?.value.name !== 'No Preference'
        "
        class="options-card-body"
        id="div_options-card-body_661d1950"
      >
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_3139e083"
        >
          Please select BOV auxiliary valve.
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_92622c3c"
        >
          <p-radioButton
            *ngFor="
              let vb of generalCartOptions['bov-aux-valve'];
              let first = first
            "
            class="checkbox-option"
            [class.first]="first"
            name="bov-aux-valve"
            formControlName="bov-aux-valve"
            [label]="vb.name"
            [value]="vb"
            id="p-radioButton_checkbox-option_7d09cb23"
          ></p-radioButton>
        </div>
      </div>

      <!--PLATFORM REQUIREMENTS-->
      <div class="options-card-body" id="div_options-card-body_725ce87f">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_d21026c6"
        >
          Do you have platform requirements?
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_9ba2c6b7"
        >
          <p-radioButton
            *ngFor="
              let plat of generalCartOptions['platform-reqs'];
              let idx = first
            "
            class="checkbox-option"
            [class.first]="idx"
            name="platform-reqs"
            formControlName="platform-reqs"
            [label]="plat.name"
            [value]="plat"
            id="p-radioButton_checkbox-option_54615dc6"
          ></p-radioButton>

          <div
            *ngIf="
              generalCartForm.controls['platform-reqs'].invalid &&
              (generalCartForm.controls['platform-reqs'].dirty ||
                generalCartForm.controls['platform-reqs'].touched)
            "
            class="error-text"
            id="div_error-text_6f2affbd"
          >
            <div
              *ngIf="
                generalCartForm.controls['platform-reqs'].errors?.['required']
              "
              id="div_1f471f46"
            >
              Required field
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--GASKET & O-RINGS CARD-->
  <div class="options-card" id="div_options-card_00d9f65c">
    <div class="options-card-header" id="div_options-card-header_04bc88b7">
      GASKETS & O-RINGS
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_43d78b43"
    >
      <!--MANWAY COVER GASKET-->
      <div class="options-card-body" id="div_options-card-body_8439ccbe">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_23e4d56a"
        >
          Manway cover gasket
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_9ffdcda9"
        >
          <p-multiSelect
            placeholder="Select manway gasket"
            styleClass="multi-select-pressure-cart"
            #manwaySelect=""
            [inputId]="'manway'"
            optionLabel="name"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            [filter]="!otherManwaySelected"
            [filterValue]="manwayFilterText"
            [showHeader]="!otherManwaySelected"
            [showClear]="false"
            formControlName="manway-gasket"
            [class.error-label]="
              generalCartForm.controls['manway-gasket'].invalid &&
              (generalCartForm.controls['manway-gasket'].dirty ||
                generalCartForm.controls['manway-gasket'].touched)
            "
            [options]="generalCartOptions['manway-gasket']"
            (onPanelHide)="addNewManwayGasket(manwaySelect)"
            (onChange)="checkManwayGasketValue($event, newManwayGasketInput)"
            id="p-multiSelect_ecac5b03"
          >
            <p-footer [hidden]="!otherManwaySelected" id="p-footer_f9fde721">
              <div
                class="multi-select-add-input"
                id="div_multi-select-add-input_ee717d35"
              >
                <input
                  [(ngModel)]="newManwayGasketText"
                  #newManwayGasketInput=""
                  [ngModelOptions]="{ standalone: true }"
                  (keyup.enter)="addNewManwayGasket(manwaySelect)"
                  placeholder="Enter text"
                  autofocus=""
                  type="text"
                  id="input_4794159b"
                />
              </div>
            </p-footer>

            <ng-template let-fg="" pTemplate="item" id="ng-template_8e203596">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_66513149"
              >
                <div id="div_cd0bc053">{{ fg.name }}</div>
              </div>
            </ng-template>

            <ng-template pTemplate="empty" id="ng-template_ff995740">
              <div fxLayout="column" id="div_cbc8398b">
                <div
                  fxLayout="column"
                  [hidden]="otherManwaySelected"
                  id="div_348305a6"
                >
                  <div [hidden]="otherManwaySelected" id="div_c10933b9">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="showAddManwayGasket(newManwayGasketInput)"
                      [binary]="true"
                      [(ngModel)]="otherManwaySelected"
                      id="p-checkbox_9a353710"
                    ></p-checkbox>
                  </div>
                </div>

                <div
                  style="margin-bottom: -22px"
                  [hidden]="!otherManwaySelected"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  id="div_90361822"
                >
                  <div id="div_6eea2362">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="focusFilterInput(manwaySelect)"
                      [binary]="true"
                      [(ngModel)]="otherManwaySelected"
                      id="p-checkbox_221af02e"
                    ></p-checkbox>
                  </div>

                  <button
                    (click)="hideAddManwayGasket(manwaySelect)"
                    pButton=""
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                    id="button_p-button-rounded_c044a597"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              generalCartForm.controls['manway-gasket'].invalid &&
              (generalCartForm.controls['manway-gasket'].dirty ||
                generalCartForm.controls['manway-gasket'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_ba7d838a"
          >
            <div
              *ngIf="
                generalCartForm.controls['manway-gasket'].errors?.['required']
              "
              id="div_eed5dbb7"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <!--FLANGE GASKET-->
      <div class="options-card-body" id="div_options-card-body_a8c25539">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_d472c5b5"
        >
          Flange gasket
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_d3a4b021"
        >
          <p-multiSelect
            styleClass="multi-select-pressure-cart"
            #flangeGasketSelect=""
            inputId="flange"
            placeholder="Select flange gasket"
            optionLabel="name"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            name="flange-gasket"
            formControlName="flange-gasket"
            [class.error-label]="
              generalCartForm.controls['flange-gasket'].invalid &&
              (generalCartForm.controls['flange-gasket'].dirty ||
                generalCartForm.controls['flange-gasket'].touched)
            "
            [filterValue]="flangeFilterValue"
            [showClear]="false"
            [filter]="!otherFlangeSelected"
            [showHeader]="!otherFlangeSelected"
            [options]="generalCartOptions['flange-gasket']"
            (onPanelHide)="addNewFlange(flangeGasketSelect)"
            (onChange)="checkFlangeValue($event, newFlangeInput)"
            id="p-multiSelect_5bb11171"
          >
            <p-footer [hidden]="!otherFlangeSelected" id="p-footer_df3c413d">
              <div
                class="multi-select-add-input scale-in-ver-top"
                id="div_multi-select-add-input_f23ebfa7"
              >
                <input
                  [(ngModel)]="newFlangeText"
                  [ngModelOptions]="{ standalone: true }"
                  #newFlangeInput=""
                  (keyup.enter)="addNewFlange(flangeGasketSelect)"
                  placeholder="Enter text"
                  autofocus=""
                  type="text"
                  id="input_2df821ab"
                />
              </div>
            </p-footer>

            <ng-template let-fg="" pTemplate="item" id="ng-template_de9720d0">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_60a6a402"
              >
                <div id="div_3c4ba22b">{{ fg.name }}</div>
              </div>
            </ng-template>

            <ng-template pTemplate="empty" id="ng-template_4cb3c8be">
              <div fxLayout="column" id="div_c0b3e458">
                <div
                  fxLayout="column"
                  [hidden]="otherFlangeSelected"
                  id="div_683c9cda"
                >
                  <div [hidden]="otherFlangeSelected" id="div_45470306">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="showAddFlange(newFlangeInput)"
                      [binary]="true"
                      [(ngModel)]="otherFlangeSelected"
                      id="p-checkbox_bac3c45c"
                    ></p-checkbox>
                  </div>
                </div>

                <div
                  style="margin-bottom: -22px"
                  [hidden]="!otherFlangeSelected"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  id="div_80a70698"
                >
                  <div id="div_f81b42be">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="focusFilterInput(flangeGasketSelect)"
                      [binary]="true"
                      [(ngModel)]="otherFlangeSelected"
                      id="p-checkbox_3b66fe66"
                    ></p-checkbox>
                  </div>

                  <button
                    (click)="hideAddFlange(flangeGasketSelect)"
                    pButton=""
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                    id="button_p-button-rounded_5073a9b9"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              generalCartForm.controls['flange-gasket'].invalid &&
              (generalCartForm.controls['flange-gasket'].dirty ||
                generalCartForm.controls['flange-gasket'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_ef5e1dee"
          >
            <div
              *ngIf="
                generalCartForm.controls['flange-gasket'].errors?.['required']
              "
              id="div_6b158fc7"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <!--BOV CAP GASKET-->
      <div class="options-card-body" id="div_options-card-body_105d02b0">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_6d63594d"
        >
          BOV cap gasket
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_aa5b7adf"
        >
          <p-multiSelect
            styleClass="multi-select-pressure-cart"
            #bovCapSelect=""
            inputId="bovCap"
            placeholder="Select BOV cap gasket"
            optionLabel="name"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            name="bov-gasket"
            formControlName="bov-gasket"
            [class.error-label]="
              generalCartForm.controls['bov-gasket'].invalid &&
              (generalCartForm.controls['bov-gasket'].dirty ||
                generalCartForm.controls['bov-gasket'].touched)
            "
            [filterValue]="bovCapFilterValue"
            [showClear]="false"
            [filter]="!otherbovCapSelected"
            [showHeader]="!otherbovCapSelected"
            [options]="generalCartOptions['bov-gasket']"
            (onPanelHide)="addNewbovCap(bovCapSelect)"
            (onChange)="checkbovCapValue($event, newbovCapInput)"
            id="p-multiSelect_1747ee56"
          >
            <p-footer [hidden]="!otherbovCapSelected" id="p-footer_146fb055">
              <div
                class="multi-select-add-input scale-in-ver-top"
                id="div_multi-select-add-input_414a6ef4"
              >
                <input
                  [(ngModel)]="newbovCapText"
                  [ngModelOptions]="{ standalone: true }"
                  #newbovCapInput=""
                  (keyup.enter)="addNewbovCap(bovCapSelect)"
                  placeholder="Enter text"
                  autofocus=""
                  type="text"
                  id="input_6f880eb9"
                />
              </div>
            </p-footer>

            <ng-template let-fg="" pTemplate="item" id="ng-template_559d0684">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_2027056e"
              >
                <div id="div_531bad8d">{{ fg.name }}</div>
              </div>
            </ng-template>

            <ng-template pTemplate="empty" id="ng-template_8db4a3e4">
              <div fxLayout="column" id="div_64a7a9d3">
                <div
                  fxLayout="column"
                  [hidden]="otherbovCapSelected"
                  id="div_2ac8129c"
                >
                  <div [hidden]="otherbovCapSelected" id="div_89c28bf6">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="showAddbovCap(newbovCapInput)"
                      [binary]="true"
                      [(ngModel)]="otherbovCapSelected"
                      id="p-checkbox_0193cdea"
                    ></p-checkbox>
                  </div>
                </div>

                <div
                  style="margin-bottom: -22px"
                  [hidden]="!otherbovCapSelected"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  id="div_61f7869e"
                >
                  <div id="div_e95a7626">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="focusFilterInput(bovCapSelect)"
                      [binary]="true"
                      [(ngModel)]="otherbovCapSelected"
                      id="p-checkbox_6ed6d7ee"
                    ></p-checkbox>
                  </div>

                  <button
                    (click)="hideAddbovCap(bovCapSelect)"
                    pButton=""
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                    id="button_p-button-rounded_076f95b9"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              generalCartForm.controls['bov-gasket'].invalid &&
              (generalCartForm.controls['bov-gasket'].dirty ||
                generalCartForm.controls['bov-gasket'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_c761b278"
          >
            <div
              *ngIf="
                generalCartForm.controls['bov-gasket'].errors?.['required']
              "
              id="div_dbe0cf48"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <!--O-RING-->
      <div class="options-card-body" id="div_options-card-body_4ea61088">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_cc819915"
        >
          O-ring
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_c9760d33"
        >
          <p-multiSelect
            placeholder="Select o-ring type"
            styleClass="multi-select-pressure-cart"
            #oringSelect=""
            inputId="oring"
            optionLabel="name"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            [filter]="!otherSelectedoRing"
            [showHeader]="!otherSelectedoRing"
            (onChange)="checkOringValue($event, newOringInput)"
            (onPanelHide)="addNewOring(oringSelect)"
            [filterValue]="oringFilterValue"
            [showClear]="false"
            formControlName="o-ring"
            [class.error-label]="
              generalCartForm.controls['o-ring'].invalid &&
              (generalCartForm.controls['o-ring'].dirty ||
                generalCartForm.controls['o-ring'].touched)
            "
            [options]="generalCartOptions['o-ring']"
            id="p-multiSelect_8a1ada19"
          >
            <p-footer [hidden]="!otherSelectedoRing" id="p-footer_f330f682">
              <div
                class="multi-select-add-input"
                id="div_multi-select-add-input_65b688fc"
              >
                <input
                  [(ngModel)]="newOringText"
                  [ngModelOptions]="{ standalone: true }"
                  #newOringInput=""
                  (keyup.enter)="addNewOring(oringSelect)"
                  placeholder="Enter text"
                  autofocus=""
                  type="text"
                  id="input_837adc1c"
                />
              </div>
            </p-footer>

            <ng-template
              let-oring=""
              pTemplate="item"
              id="ng-template_23744ace"
            >
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_28e35ac3"
              >
                <div id="div_fbbaf28c">{{ oring.name }}</div>
              </div>
            </ng-template>

            <ng-template pTemplate="empty" id="ng-template_20a5bfd3">
              <div fxLayout="column" id="div_1062a43f">
                <div
                  fxLayout="column"
                  [hidden]="otherSelectedoRing"
                  id="div_380ce8ac"
                >
                  <div [hidden]="otherSelectedoRing" id="div_271717bc">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="showAddOring(newOringInput)"
                      [binary]="true"
                      [(ngModel)]="otherSelectedoRing"
                      id="p-checkbox_f67478c8"
                    ></p-checkbox>
                  </div>
                </div>

                <div
                  style="margin-bottom: -22px"
                  [hidden]="!otherSelectedoRing"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  id="div_fc7f5fd7"
                >
                  <div id="div_bfdf13ec">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="focusFilterInput(oringSelect)"
                      [binary]="true"
                      [(ngModel)]="otherSelectedoRing"
                      id="p-checkbox_46a105f6"
                    ></p-checkbox>
                  </div>

                  <button
                    (click)="hideAddOring(oringSelect)"
                    pButton=""
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                    id="button_p-button-rounded_13008073"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              generalCartForm.controls['o-ring'].invalid &&
              (generalCartForm.controls['o-ring'].dirty ||
                generalCartForm.controls['o-ring'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_da84b4a7"
          >
            <div
              *ngIf="generalCartForm.controls['o-ring'].errors?.['required']"
              id="div_c51ed5e7"
            >
              Required field
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--FITTINGS & ACCESSORIES CARD-->
  <div class="options-card" id="div_options-card_70ce3f0a">
    <div class="options-card-header" id="div_options-card-header_37189d20">
      FITTINGS & ACCESSORIES
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_2190a205"
    >
      <!--MAGNETIC GAUGING-->
      <div
        class="checkbox-container-column full-width"
        id="div_checkbox-container-column_edfcad69"
      >
        <div
          class="options-card-body checkbox-body"
          id="div_options-card-body_04c46ffd"
        >
          <div
            class="options-card-subheader body-item"
            id="div_options-card-subheader_57492c54"
          >
            Magnetic gauging device settings:
          </div>

          <div
            class="checkbox-container-row vr-body body-item"
            id="div_checkbox-container-row_72fc4487"
          >
            <ng-container
              *ngFor="let fa of generalCartOptions['device-settings']"
              id="ng-container_02e634e1"
            >
              <div
                class="vertical-radio-button"
                id="div_vertical-radio-button_0eadcd68"
              >
                <label
                  class="vertical-radio-button-label"
                  [for]="fa.id"
                  id="label_vertical-radio-button-label_7ed2aa72"
                  >{{ fa.name }}</label
                >

                <p-radioButton
                  class="checkbox-option-row"
                  name="device-settings"
                  formControlName="device-settings"
                  [value]="fa"
                  id="p-radioButton_checkbox-option-row_547f1c55"
                ></p-radioButton>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="divider" id="div_divider_c8b916d6"></div>
      </div>

      <!--THERMOWELL & SAMPLE LINE-->
      <div
        class="checkbox-container-row"
        id="div_checkbox-container-row_429f20a5"
      >
        <div
          class="checkbox-container-column full-width"
          id="div_checkbox-container-column_994f40c7"
        >
          <div
            class="options-card-body radio-horizontal"
            id="div_options-card-body_e0646d22"
          >
            <div
              class="options-card-subheader body-item"
              id="div_options-card-subheader_8a7f6a8d"
            >
              Do you need a thermowell?
            </div>

            <div
              class="checkbox-container-row vr-body body-item"
              id="div_checkbox-container-row_87f6217f"
            >
              <div
                class="vertical-radio-button"
                id="div_vertical-radio-button_7ccc2ff1"
              >
                <label
                  class="vertical-radio-button-label"
                  [innerHTML]="generalCartOptions['need-thermowell'][0].name"
                  id="label_vertical-radio-button-label_0146a60c"
                ></label>

                <p-radioButton
                  name="need-thermowell"
                  [value]="generalCartOptions['need-thermowell'][0]"
                  formControlName="need-thermowell"
                  class="checkbox-option-row"
                  id="p-radioButton_checkbox-option-row_6e035947"
                >
                </p-radioButton>
              </div>

              <div
                class="vertical-radio-button"
                id="div_vertical-radio-button_55817b66"
              >
                <label
                  class="vertical-radio-button-label"
                  id="label_vertical-radio-button-label_7a32ae97"
                  >{{ generalCartOptions['need-thermowell'][1].name }}</label
                >

                <p-radioButton
                  name="need-thermowell"
                  [value]="generalCartOptions['need-thermowell'][1]"
                  formControlName="need-thermowell"
                  class="checkbox-option-row"
                  id="p-radioButton_checkbox-option-row_d446c064"
                >
                </p-radioButton>
              </div>

              <div
                class="vertical-radio-button"
                id="div_vertical-radio-button_7645a3a3"
              >
                <label
                  class="vertical-radio-button-label"
                  id="label_vertical-radio-button-label_0200fd90"
                  >{{ generalCartOptions['need-thermowell'][2].name }}</label
                >

                <p-radioButton
                  name="need-thermowell"
                  [value]="generalCartOptions['need-thermowell'][2]"
                  formControlName="need-thermowell"
                  class="checkbox-option-row"
                  id="p-radioButton_checkbox-option-row_84e73ec2"
                >
                </p-radioButton>
              </div>
            </div>
          </div>

          <div
            class="checkbox-container-row"
            id="div_checkbox-container-row_3b58d888"
          >
            <div
              class="options-card-body radio-horizontal"
              id="div_options-card-body_72d877af"
            >
              <div
                class="options-card-subheader body-item"
                id="div_options-card-subheader_00cc5171"
              >
                Do you need a sample line?
              </div>

              <div
                class="checkbox-container-row vr-body body-item"
                id="div_checkbox-container-row_32d8450d"
              >
                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_fcf5dd9c"
                >
                  <label
                    class="vertical-radio-button-label spacer"
                    [innerHTML]="generalCartOptions['need-sample_line'][0].name"
                    id="label_vertical-radio-button-label_86326c44"
                  ></label>

                  <p-radioButton
                    name="need-sample_line"
                    [value]="generalCartOptions['need-sample_line'][0]"
                    formControlName="need-sample_line"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_4054bf70"
                  >
                  </p-radioButton>
                </div>

                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_694b6406"
                >
                  <label
                    class="vertical-radio-button-label spacer"
                    id="label_vertical-radio-button-label_26c3d996"
                    >{{ generalCartOptions['need-sample_line'][1].name }}</label
                  >

                  <p-radioButton
                    name="need-sample_line"
                    class="checkbox-option-row"
                    formControlName="need-sample_line"
                    [value]="generalCartOptions['need-sample_line'][1]"
                    id="p-radioButton_checkbox-option-row_5c2fc423"
                  >
                  </p-radioButton>
                </div>

                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_723676cb"
                >
                  <label
                    class="vertical-radio-button-label spacer"
                    id="label_vertical-radio-button-label_e1a13481"
                    >{{ generalCartOptions['need-sample_line'][2].name }}</label
                  >

                  <p-radioButton
                    name="need-sample_line"
                    [value]="generalCartOptions['need-sample_line'][2]"
                    formControlName="need-sample_line"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_1c447910"
                  >
                  </p-radioButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--INTERIOR PREP CARD-->
  <div class="options-card" id="div_options-card_e56766f3">
    <div class="options-card-header" id="div_options-card-header_10c60dbc">
      INTERIOR PREP
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_48dea134"
    >
      <!--SPECIAL REQUIREMENTS-->
      <div class="options-card-body" id="div_options-card-body_06f0c8af">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_33af2c93"
        >
          Does your product have any special requirements?
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_ac2a49b1"
        >
          <p-checkbox
            class="checkbox-option"
            *ngFor="
              let option of generalCartOptions['special-reqs'];
              let first = first
            "
            [class.first]="first"
            [value]="option"
            [formControl]="$any(generalCartForm).controls['special-reqs']"
            (onChange)="checkSpecialReqValue($event, newSpecialReqInput)"
            [label]="option.name"
            id="p-checkbox_checkbox-option_2e889bc5"
          ></p-checkbox>

          <div
            [hidden]="!addingSpecialReq"
            class="select-add-input scale-in-ver-top"
            id="div_select-add-input_a810e5a9"
          >
            <input
              #newSpecialReqInput=""
              [ngModelOptions]="{ standalone: true }"
              (change)="addingOtherValue('SpecialReq')"
              [(ngModel)]="newSpecialReqText"
              autofocus=""
              placeholder="Enter text"
              id="input_617990a5"
            />
          </div>

          <div
            *ngIf="
              generalCartForm.controls['special-reqs'].invalid &&
              (generalCartForm.controls['special-reqs'].dirty ||
                generalCartForm.controls['special-reqs'].touched)
            "
            class="error-text"
            id="div_error-text_17f05fc8"
          >
            <div
              *ngIf="
                generalCartForm.controls['special-reqs'].errors?.['required']
              "
              id="div_1d3df074"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <div class="divider" id="div_divider_7fabb70b"></div>

      <!--LINING TYPE-->
      <div class="options-card-body" id="div_options-card-body_0f5a9901">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_079b2b59"
        >
          What lining type do you prefer?
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_dab96af3"
        >
          <p-dropdown
            placeholder="Select lining type"
            optionLabel="name"
            [autofocus]="true"
            [options]="generalCartOptions['lining-type']"
            formControlName="lining-type"
            [class.error-label]="
              generalCartForm.controls['lining-type'].invalid &&
              (generalCartForm.controls['lining-type'].dirty ||
                generalCartForm.controls['lining-type'].touched)
            "
            (onChange)="checkLiningTypeValue($event, newLiningInput)"
            id="p-dropdown_f5fe5485"
          >
            <ng-template let-fg="" pTemplate="item" id="ng-template_3a675cdd">
              <div
                *ngIf="
                  fg.id !== generalCartForm.controls['lining-type'].value.id
                "
                class="checkbox-container-row"
                id="div_checkbox-container-row_d12a5915"
              >
                <div id="div_152824f8">{{ fg.name }}</div>
              </div>

              <div
                *ngIf="
                  fg.id === generalCartForm.controls['lining-type'].value.id
                "
                fxLayout="row"
                fxLayoutAlign="start center"
                id="div_ca24f858"
              >
                <i
                  style="margin-right: 18px"
                  class="pi pi-check"
                  id="i_pi_5cccb732"
                ></i>
                <div id="div_e98ff61f">{{ fg.name }}</div>
              </div>
            </ng-template>
          </p-dropdown>

          <div
            [hidden]="!addingLiningTypes"
            class="select-add-input scale-in-ver-top"
            id="div_select-add-input_0c1337a2"
          >
            <input
              #newLiningInput=""
              [ngModelOptions]="{ standalone: true }"
              (change)="addingOtherValue('LiningType')"
              [(ngModel)]="newLiningTypeText"
              autofocus=""
              placeholder="Enter text"
              id="input_2c70549e"
            />
          </div>

          <div
            *ngIf="
              generalCartForm.controls['lining-type'].invalid &&
              (generalCartForm.controls['lining-type'].dirty ||
                generalCartForm.controls['lining-type'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_1495ed33"
          >
            <div
              *ngIf="
                generalCartForm.controls['lining-type'].errors?.['required']
              "
              id="div_4cfee2d1"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <div class="divider" id="div_divider_c2c292bb"></div>

      <!--INTERIOR & INTERIOR SURFACE PREP-->
      <div class="options-card-body" id="div_options-card-body_bcb01ca7">
        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_18e178b1"
        >
          <div
            class="options-card-subheader"
            fxLayoutAlign="start center"
            fxLayout="row"
            id="div_options-card-subheader_d806cf88"
          >
            <div
              [class.info-dialog-shown]="displayInteriorPrepHelp"
              fxLayoutAlign="start center"
              fxLayout="row"
              id="div_74aee82a"
            >
              INTERIOR PREP
              <i
                (click)="displayInteriorPrepHelp = true"
                class="pi pi-info-circle prep-info-button"
                id="i_pi_9d6c37ae"
              ></i>
            </div>

            <div
              *ngIf="displayInteriorPrepHelp"
              class="dialog-tooltip-container"
              id="div_dialog-tooltip-container_2dce12b1"
            >
              <div class="dialog-tooltip" id="div_dialog-tooltip_1b6c01eb">
                <div class="dialog-title" id="div_dialog-title_20a388ff">
                  Interior Prep
                </div>

                <div style="width: 386px; height: 131px" id="div_5ae18375">
                  Standards are defined by The Association for Materials <br />
                  Protection and Performance. For details, visit <br />
                  <a
                    aria-label="TRM about"
                    title="TRM about"
                    target="_blank"
                    href="https://www.ampp.org/about"
                    id="a_893fa04d"
                    >ampp.org/about</a
                  >
                  or see SSPC-VIS 1 Standards for Dry <br />
                  Abrasive Blast Cleaning.
                </div>
              </div>
            </div>
          </div>

          <ng-container
            *ngFor="let ox of generalCartOptions['interior-prep']"
            id="ng-container_6ae9babd"
          >
            <p-radioButton
              class="checkbox-option"
              name="interior-prep"
              formControlName="interior-prep"
              [value]="ox"
              (ngModelChange)="checkRadioOtherValue($event, 'InteriorPrep')"
              [label]="ox.name"
              id="p-radioButton_checkbox-option_3b8bfaea"
            ></p-radioButton>
          </ng-container>

          <div
            [hidden]="!addinginteriorPrep"
            class="select-add-input scale-in-ver-top"
            id="div_select-add-input_88322ebd"
          >
            <input
              [ngModelOptions]="{ standalone: true }"
              #newInteriorInput=""
              (change)="addingOtherValue('InteriorPrep')"
              [(ngModel)]="newinteriorPrepText"
              autofocus=""
              placeholder="Enter text"
              id="input_bf963289"
            />
          </div>
        </div>

        <div
          class="checkbox-container-column body-item"
          id="div_checkbox-container-column_ef78dc39"
        >
          <div
            class="options-card-subheader"
            ngClass.lt-lg="lt-lg"
            id="div_options-card-subheader_fa3e1a94"
          >
            Interior Surface Prep
          </div>

          <ng-container
            *ngFor="let fa of generalCartOptions['interior_surface_prep']"
            id="ng-container_0ef1daaf"
          >
            <p-radioButton
              class="checkbox-option"
              name="interior_surface_prep"
              formControlName="interior_surface_prep"
              [value]="fa"
              [label]="fa.name"
              (ngModelChange)="
                checkRadioOtherValue($event, 'InteriorSurfacePrep')
              "
              id="p-radioButton_checkbox-option_fbc8a164"
            ></p-radioButton>
          </ng-container>

          <div
            [hidden]="!addinginteriorSurfacePrep"
            class="select-add-input scale-in-ver-top"
            id="div_select-add-input_ac0e63dc"
          >
            <input
              [ngModelOptions]="{ standalone: true }"
              #newInteriorSurfaceInput=""
              (change)="addingOtherValue('InteriorSurfacePrep')"
              [(ngModel)]="newinteriorSurfacePrepText"
              autofocus=""
              placeholder="Enter text"
              id="input_d9eb6b05"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--PURGE & PAD-->
  <div class="options-card" id="div_options-card_237c6866">
    <div class="options-card-header" id="div_options-card-header_78fdcb3f">
      PURGE & PAD
    </div>

    <div class="options-card-body" id="div_options-card-body_ba778b2f">
      <div
        class="checkbox-container-column body-item"
        id="div_checkbox-container-column_8a6c6bd2"
      >
        <div
          class="options-card-subheader"
          id="div_options-card-subheader_13c63947"
        >
          Oxygen content
        </div>

        <ng-container
          *ngFor="let ox of generalCartOptions['oxygen-content']"
          id="ng-container_83d494b5"
        >
          <p-radioButton
            class="checkbox-option"
            name="oxygen-content"
            formControlName="oxygen-content"
            [value]="ox"
            [label]="ox.name"
            (ngModelChange)="checkRadioOtherValue($event, 'OxygenContent')"
            id="p-radioButton_checkbox-option_66b1a73d"
          ></p-radioButton>
        </ng-container>

        <div
          [hidden]="!addingOxygenContent"
          class="select-add-input scale-in-ver-top"
          id="div_select-add-input_6f197fe7"
        >
          <input
            [ngModelOptions]="{ standalone: true }"
            #newOxygenContentInput=""
            (change)="addingOtherValue('OxygenContent')"
            [(ngModel)]="newOxygenContentText"
            autofocus=""
            placeholder="Enter text"
            id="input_7dad8559"
          />
        </div>
      </div>

      <div
        class="checkbox-container-column body-item"
        id="div_checkbox-container-column_01fb58c9"
      >
        <div
          class="options-card-subheader"
          ngClass.lt-lg="lt-lg"
          id="div_options-card-subheader_737f477f"
        >
          Nitrogen PSI
        </div>

        <ng-container
          *ngFor="let fa of generalCartOptions['nitrogen-psi']"
          id="ng-container_40210871"
        >
          <p-radioButton
            class="checkbox-option"
            name="nitrogen-psi"
            formControlName="nitrogen-psi"
            [value]="fa"
            [label]="fa.name"
            (ngModelChange)="checkRadioOtherValue($event, 'NitrogenPSI')"
            id="p-radioButton_checkbox-option_f386f6fc"
          ></p-radioButton>
        </ng-container>

        <div
          [hidden]="!addingNitrogenPSI"
          class="select-add-input scale-in-ver-top"
          id="div_select-add-input_ca342f5a"
        >
          <input
            #newNitrogenPSIInput=""
            [ngModelOptions]="{ standalone: true }"
            (change)="addingOtherValue('NitrogenPSI')"
            [(ngModel)]="newNitrogenPSIText"
            autofocus=""
            placeholder="Enter text"
            id="input_c8d6eced"
          />
        </div>
      </div>
    </div>
  </div>

  <input
    formControlName="selected"
    type="hidden"
    [value]="true"
    id="input_d92341fa"
  />

  <div class="button-container" id="div_button-container_80b0e4b0">
    <button
      icon="pi pi-arrow-left"
      (click)="back()"
      class="back-button"
      pButton=""
      label="Previous"
      id="button_back-button_1f5e3fba"
    ></button>

    <button
      class="quiz-button"
      styleClass="p-button-next"
      [disabled]="!generalCartForm.valid"
      (click)="next()"
      icon="pi pi-arrow-right"
      pButton=""
      label="Next"
      id="button_quiz-button_c91317d3"
    ></button>
  </div>
</ng-form>

<div
  fxLayout="column"
  fxLayoutAlign="center center"
  *ngIf="!generalCartOptions"
  id="div_93c16d33"
>
  <p-progressSpinner id="p-progressSpinner_081b6568"></p-progressSpinner>
</div>

<div
  class="info-help-dialog-click-overlay"
  (click)="displayInteriorPrepHelp = false"
  [hidden]="!displayInteriorPrepHelp"
  id="div_info-help-dialog-click-overlay_bb795af4"
></div>
